export interface MapQuestQueryInterface {
    /**
     * A valid and authorized MapQuest API key.
     */
    key: string;
}
